<h2 class="titulo">Modalidade no SCR</h2>
<bn-loading-overlay></bn-loading-overlay>
<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="row">
      <div class="col">
        <h3>Pesquisa</h3>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary no-margin" type="button" [routerLink]="['/modalidade-scr/cadastro']"><i
          class="fa fa-file-signature">
        </i> Cadatrar Modalidade
        </button>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary no-margin" type="button"
                ngbTooltip="Tela para habilitar programa permitido por cesta." [routerLink]="['habilitacao']"><i
          class="fa fa-file-signature">
        </i> Habilitar Modalidade
        </button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar()"
                (click)="buscar()">Pesquisar
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="idProduto"><b>Código modalidade: </b></label>
        <ng-select
          [items]="listaTodasModalidades"
          bindLabel="codigoScrModalidade"
          bindValue="codigoScrModalidade"
          placeholder="Todos"
          formControlName="codigoScrModalidade"
          ngDefaultControl
        >
        </ng-select>
      </div>
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="permitido"><b>Tipo modalidade: </b></label>
        <ng-select
          [items]="listaTipos"
          bindLabel="nome"
          bindValue="valor"
          placeholder="Todos"
          formControlName="tipoScrModalidade"
          ngDefaultControl
        >
        </ng-select>
      </div>
    </div>
  </form>
</div>

<app-modalidade-scr-listagem
  *ngIf="pesquisado && modalidadesNoScr.length"
  [modalidadesNoScr]="modalidadesNoScr"
  (desabilitarCodigoModalidade)="desabilitarCodigoModalidade($event)"
>
</app-modalidade-scr-listagem>

<section class="container" *ngIf="pesquisado && (!modalidadesNoScr || !modalidadesNoScr.length)">
  <div class="alert alert-info">
    Não foram encontradas modalidades no SCR com os filtros informados.
  </div>
</section>
